import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { SupplementInfoField } from '../../types';
import { isEmptyFieldValue } from '../../utils';

@Component({ name: 'EducationDegree' })
export default class EducationDegree extends Vue implements SupplementInfoField {
  @Prop()
  private value!: undefined | number;

  private educationDegree: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    this.educationDegree = this.value;

    this.options = await DictApi.getEducationLevels();
  }

  @Watch('value')
  private onPropsValueChange(val: undefined | number) {
    this.educationDegree = val;
  }

  private onChange(val: number | undefined) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  public onValidator(): boolean {
    if (isEmptyFieldValue(this.educationDegree)) {
      this.errorMsg = '请选择学历';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private render() {
    return (
      <Field
        label="学历"
        errorMessage={this.errorMsg}
      >
        <SelectInput
          v-model={this.educationDegree}
          title="选择学历"
          placeholder="选择学历"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChange}
        />
      </Field>
    );
  }
}
